import { StyleSheet } from 'react-native'

/**
 * Default styles
 */
export const BookingCreateStyles = StyleSheet.create( {
	calendarContainer: {
		width: '100%',
		flex: 1,
	},
	emptyText: {
		alignSelf: 'center'
	}
});
